import { render } from "./PropertyOwnerWorkStationModal.vue?vue&type=template&id=fd3f875e&scoped=true&ts=true"
import script from "./PropertyOwnerWorkStationModal.vue?vue&type=script&lang=ts"
export * from "./PropertyOwnerWorkStationModal.vue?vue&type=script&lang=ts"

import "./PropertyOwnerWorkStationModal.vue?vue&type=style&index=0&id=fd3f875e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd3f875e"]])

export default __exports__